import { useState, useEffect } from "react";

/**
 * Detects if the app is running inside the Fieldz AI mobile WebView.
 * The native app injects `window.FieldzNative.isNativeApp = true`.
 */
export const useIsMobileApp = () => {
  const [isMobile, setIsMobile] = useState(() => !!window.FieldzNative?.isNativeApp);

  useEffect(() => {
    // Re-check after a short delay in case the bridge is injected after initial render
    const timer = setTimeout(() => {
      setIsMobile(!!window.FieldzNative?.isNativeApp);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return isMobile;
};

/** Non-hook version for use outside components (e.g., interceptors) */
export const isMobileApp = () => !!window.FieldzNative?.isNativeApp;

/**
 * True only inside the iOS native shell. Used to keep Apple App Review
 * compliance (no in-app subscription purchases / external purchase steering
 * on iOS) while leaving Android and web behavior unchanged.
 */
export const isIOSApp = () =>
  !!window.FieldzNative?.isNativeApp && window.FieldzNative?.platform === "ios";

export const useIsIOSApp = () => {
  const [isIOS, setIsIOS] = useState(() => isIOSApp());

  useEffect(() => {
    const timer = setTimeout(() => setIsIOS(isIOSApp()), 300);
    return () => clearTimeout(timer);
  }, []);

  return isIOS;
};
